import LeadService from '_services/rest/modules/lead';

export default {
  state: {
    lead: null,
    reseller: null,
    leadList: null,
  },
  mutations: {
    setLeadList(state, response) {
      state.leadList = response;
    },
    setLead(state, response) {
      state.lead = response.lead;
      state.reseller = response.reseller;
    },
  },
  actions: {
    getLeadList({ commit }, params) {
      return LeadService.getList(params)
        .then(response => {
          commit('setLeadList', response);
        });
    },
    getLead({ commit }, params) {
      return LeadService.getLeadById(params)
        .then(lead => {
          commit('setLead', lead);
        });
    },
  },
};
